import { AccessibilityIcon, ArchiveIcon, ArrowLeftIcon, AvatarIcon, BackpackIcon, CheckCircledIcon, CheckIcon, Cross1Icon, CrossCircledIcon, DesktopIcon, EnvelopeClosedIcon, ExclamationTriangleIcon, FileTextIcon, IdCardIcon, InfoCircledIcon, LockOpen1Icon, LockOpen2Icon, PersonIcon, PinLeftIcon, PinTopIcon, PlusCircledIcon, RocketIcon, UpdateIcon, UploadIcon } from "@radix-ui/react-icons"
import { Box, Button, Container, Flex, Heading, Text, TextField, Skeleton, Callout, Select, ScrollArea, TextArea, Badge, Spinner, } from "@radix-ui/themes"
import React, { useEffect, useMemo, useState } from "react"
import {AUTHED_ROUTES, ROUTES} from '../../routes/constants'
import PasswordInput from "../../components/controls/inputs/PasswordInput"
import useFetch from '../../core/hooks/useFetch'
import {IUser} from '../../core/types/services-types/user-types'
import UserService from '../../core/services/UserService'
import {useAppSelector} from '../../core/store'
import PhoneInput from "../../components/controls/inputs/PhoneInput"
import CardInput from "../../components/controls/inputs/CardInput"
import { ToastContainer, toast } from 'react-toastify';
import FileInput from '../../components/controls/inputs/FIleInput'
import { FileArray } from "../admin/create-post"
import ContractService from '../../core/services/ContractService'
import { Link, useNavigate } from "react-router"
import { IContract } from "../../core/types/services-types/contract-types"
import AdminService from "../../core/services/AdminService"
import { ISettings } from "../../core/types/services-types/admin-types"
import { Document, Page } from "react-pdf"
import Pagination from "../../components/common/renders/pagination-render"
import BaseModal from "../../components/controls/modals/BaseModal"
import BillService from '../../core/services/BillService'
import {IBill} from '../../core/types/services-types/bill-types'
import TransactionService from '../../core/services/TransactionService'
import { UserRoles } from "../../core/types/constants/user"
export default function Account() {
    const [settingsSite, setSettingsSite] = useState<ISettings>()
    const [changeData, setChangeData] = useState<boolean>(false)
    const [changePassword, setChangePassword] = useState<boolean>(false)
    const user = useAppSelector(store => store.user)
    const [userData, setUserData] = useState<IUser>()
    const [email, setEmail] = useState<string>('')
    const [phoneNumber, setPhoneNumber] = useState<string>('')
    const [cardNumber, setCardNumber] = useState<string>('')
    const [oldPassword, setOldPassword] = useState<string>('')
    const [newPassword, setNewPassword] = useState<string>('')
    const [adminPanel, setAdminPanel] = useState<boolean>(false)
    const [contracts, setContracts] = useState<IContract[]>([])
    const [limitContracts, setLimitContracts] = useState<number>(100)
    const [pageContracts, setPageContracts] = useState<number>(0)
    const [totalCountContracts, setTotalCountContracts] = useState<number>(0)

    // kyc
    const [firstName, setFirstName] = useState('')
    const [secondName, setSecondName] = useState('')
    const [surName, setSurName] = useState('')
    const [personDocument, setPersonDocument] = useState('Паспорт гражданина РФ')
    const [seriesNumberPassport, setSeriesNumberPassport] = useState('')
    const [dateOfIssue, setDateOfIssue] = useState('')
    const [whomIssue, setWhomIssue] = useState('')
    const [placeOfResidence, setPlaceOfResidence] = useState('')
    const [fileBirthCertificate, setFileBirthSertificate] = useState<FileArray[]>([])
    const [filePassport, setFilePassport] = useState<FileArray[]>([])
    const [fileNationalityCertificate, setFileNationalityCertificate] = useState<FileArray[]>([])
    const [fileSelfiePassport, setFileSelfiePassport] = useState<FileArray[]>([])
    const [fileAutobiography, setFileAutobiography] = useState<FileArray[]>([])
    const [fileOtherDocuments, setFileOtherDocuments] = useState<FileArray[]>([])

    // sending contracts

    const [titleContract, setTitleContract] = useState<string>('')
    const [typeContract, setTypeContract] = useState<string>('Загрузка личных документов')
    const [descriptionContract, setDescriptionContract] = useState<string>('')
    const [pdfFileContract, setPDFFileContract] = useState<FileArray[]>([])


    // bills
    const [totalBills, setTotalBills] = useState<number>(0)
    const [bills, setBills] = useState<IBill[]>([])
    const [pageBills, setPageBills] = useState<number>(0)
    const [limitBills, setLimitBills] = useState<number>(100)
    const [newBillFile, setNewBillFile] = useState<FileArray[]>([])


    const [fetchContracts, isLoadingFetchContracts, errorFetchContracts, errorsFetchContracts] = useFetch(async () => {
        if(userData) {
        const data = await ContractService.GetAllUser(userData?.id, limitContracts, pageContracts)
        setContracts(data.data)
        setTotalCountContracts(data.count)
        }
    })

    const [fetchSetJoiningService, isLoadingFetchSetJoiningService, errorFetchSetJoiningService, errorsFetchSetJoiningService] = useFetch(async () => {
            const data = await UserService.SetStatusJoiningService()
            toast.success("Вы успешно присоединились к сервису! Теперь вы мождете участвовать в проектах")
               await getMyAccount()
    })

    const [fetchUnsetJoiningService, isLoadingFetchUnsetJoiningService, errorFetchUnsetJoiningService, errorsFetchUnsetJoiningService] = useFetch(async () => {
            const data = await UserService.UnsetStatusJoiningService()
            toast.info("Вы успешно отписались от сервиса! Теперь вы не можете участвовать в проектах")
            await getMyAccount()
    })


    const [fetchSettingsSite, isLoadingSettingsSite, errorSettingsSite, errorsSettingsSite] = useFetch(async () => {
                const data = await AdminService.GetSettingsSite()
                setSettingsSite(data)
    })


    const [fetchBillForUser, isLoadingBillForUser, errorBillForUser, errorsBillForUser] = useFetch(async () => {
        const data = await BillService.GetBillsForUser(limitBills, pageBills)
        setTotalBills(data.count)
        setBills(prev => data.data)
    })

    const [fetchNewBill, isLoadingFetchNewBill, errorFetchNewBill, errorsFetchNewBill] = useFetch(async () => {
        if(newBillFile.length) {
            const formData = new FormData()
            formData.append('bill-file', newBillFile[0].file, newBillFile[0].name)
            const data = await BillService.BillUser(formData)
            setNewBillFile([])
            setBills(prev => [...prev, data])
            toast.success("Счет успешно выставлен! Можете скачать файл из списка ниже")
            return
        }
        toast.error("Выберите файл счета в формате .docx")
    })
        
    const [fetchRemoveBill, isLoadingFetchRemoveBill, errorFetchRemoveBill, errorsFetchRemoveBill] = useFetch(async (id: number | string) => {
        await BillService.Remove(id)
        setBills(prev => prev.filter(item => item.id !== id))
        toast.success("Счет успешно удален!")
    })

    const navigate = useNavigate()


    const [getMyAccount, isLoading, error, errors] = useFetch(async () => {
        const data = await UserService.Get(user.user.id)
        setUserData(data)
        setCardNumber(data.card_number || '')
        setEmail(data.email || '')
        setPhoneNumber(data.phone_number || '')
        setFirstName(data.first_name || '')
        setSecondName(data.second_name || '')
        setSurName(data.sur_name || '')
        setPersonDocument(data.document_person || 'Паспорт гражданина РФ')
        setSeriesNumberPassport(data.series_number_passport || '')
        setDateOfIssue(data.date_issue_passport || '')
        setWhomIssue(data.whom_issue_passport || '')
        setPlaceOfResidence(data.place_of_residence || '')
    })
   
    const [updateData, isLoadingChangingData, errorUpdateData, errorsUpdateData] = useFetch(async () => {
        const data = await UserService.Update({email, card_number: cardNumber, phone_number: phoneNumber})
        setUserData(data)
        setCardNumber(data.card_number || '')
        setEmail(data.email || '')
        setPhoneNumber(data.phone_number || '')
        toast.success("Данные успешно изменены!")
    })

    const [fetchAddPersonData, isLoadingFetchPersonData, errorFetchPersonData, errorsFetchPersonData]= useFetch(async () => {
        console.log(personDocument)
        await UserService.AddPersonData(firstName, secondName, surName, personDocument, seriesNumberPassport, dateOfIssue, whomIssue, placeOfResidence)
        toast.success("Вы обновили свои данные, теперь отправьте документы через форму ниже")
        await getMyAccount()
    })


    // TODO: OPTIMIZATION
    const [fetchContract, isLoadingFetchContract, errorFetchContract, errorsFetchContract] = useFetch(async () => {
        const formData = new FormData()
        formData.append('title', titleContract)
        formData.append('type', typeContract)
        if(pdfFileContract) {
        pdfFileContract.forEach(file => {
            formData.append('pdf', file.file, file.name)
        })
    }
        await ContractService.Create(formData)
        setPDFFileContract([])
        setDescriptionContract('')
        setTitleContract('')
    })

    // TODO: OPTIMIZATION
    const [fetchContractPersonalInformation, isLoadingFetchContractPersonalInformation, errorFetchContractPersonalInformation, errorsFetchContractPersonalInformation] = useFetch(async () => {
        if(!fileBirthCertificate && !filePassport && !fileNationalityCertificate && !fileSelfiePassport && !fileAutobiography && !fileOtherDocuments) {
            toast.error("Загрузите хотя бы один документ!")
        }
        const formData = new FormData()
        formData.append('title', titleContract)
        formData.append('type', typeContract)
        if(fileBirthCertificate) {
            fileBirthCertificate.forEach(file => {
                formData.append('file_birth_certificate', file.file, file.name)
            })
        }
        if(filePassport) {
            filePassport.forEach(file => {
                formData.append('file_passport', file.file, file.name)
            })
        }
        if(fileNationalityCertificate) {
            fileNationalityCertificate.forEach(file => {
                formData.append('file_nationality_certificate', file.file, file.name)
            })
        }
        if(fileAutobiography) {
            fileAutobiography.forEach(file => {
                formData.append('file_autobiography', file.file, file.name)
            })
        }
        if(fileOtherDocuments) {
            fileOtherDocuments.forEach(file => {
                formData.append('file_other_documents', file.file, file.name)
            })
        }
        await ContractService.CreatePersonalInformation(formData)
        setTitleContract('')
        setFileBirthSertificate([])
        setFilePassport([])
        setFileNationalityCertificate([])
        setFileSelfiePassport([])
        setFileAutobiography([])
        setFileOtherDocuments([])
    })

    const [fetchSendMoneyesToMinfinFromReserveBalance, isLoadingSendMoneysToMinfinFromReserveBalance, errorSendMoneysToMinfinFromReserveBalance, errorsSendMoneysToMinfinFromReserveBalance] = useFetch(async () => {
        const data = await TransactionService.SendMoneysToMinfinFromReserveBalance()
        if(userData) {
            setUserData(prev => {
                if(!prev) return prev
                return {
                    ...prev,
                    reserve_cash_site: 0
                }
            })
        }
        toast.success(data.message)
    })

    const [updatePassword, isLoadingPassword, errorUpdatePassword, errorsUpdatePassword] = useFetch(async () => {
        await UserService.UpdatePassword({oldPassword, newPassword})
        setOldPassword('')
        setNewPassword('')
        toast.success("Пароль успешно изменен!")
    })

    const handleRemoveFilePDf = (id: number, setFile: (value: React.SetStateAction<FileArray[]>) => void) => {
            setFile((prevFiles) => prevFiles.filter((file) => file.id !== id));
    }

        const [numPages, setNumPages] = useState<number>(0);
        const [pageNumber, setPageNumber] = useState<number>(1);
      
        function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
          setNumPages(numPages);
        }

       const renderContentPdfModalContractJoiningService =  (
        
       <Container> 
      <Document file={settingsSite?.document_joining_service} onLoadSuccess={onDocumentLoadSuccess}>
        <Page pageNumber={pageNumber} />
      </Document>
       <Pagination total={numPages} count={1} activeIndex={pageNumber} onChangeIndex={setPageNumber} classNameContainer="flex-wrap"/>
      </Container>
    )
    

    useEffect(() => {
        console.log(user)
      if(user.user) {
      getMyAccount()
      }
    }, [user])
    useEffect(() => {
        fetchContracts()
    }, [userData])
    useEffect(() => {
        fetchSettingsSite()
    }, [])
    useEffect(() => {
        if(error.length) toast.error(error)
    }, [error])
    useEffect(() => {
       if(errorUpdateData.length) toast.error(errorUpdateData)
    }, [errorUpdateData])
    useEffect(() => {
       if(errorUpdatePassword.length) toast.error(errorUpdatePassword)
    }, [errorUpdatePassword])
    useEffect(() => {
        if(errorFetchPersonData.length) toast.error(errorFetchPersonData)
    }, [errorFetchPersonData])
    useEffect(() => {
        if(errorFetchSetJoiningService.length) toast.error(errorFetchSetJoiningService)
    }, [errorFetchSetJoiningService])
    useEffect(() => {
        if(errorFetchUnsetJoiningService.length) toast.error(errorFetchUnsetJoiningService)
    }, [errorFetchUnsetJoiningService])
    useEffect(() => {
        if(errorFetchContract.length) toast.error(errorFetchContract)
    }, [errorFetchContract])
    useEffect(() => {
        if(errorFetchContractPersonalInformation.length) toast.error(errorFetchContractPersonalInformation)
    }, [errorFetchContractPersonalInformation])
    useEffect(() => {
        if(errorBillForUser) toast.error(errorBillForUser)
    }, [errorBillForUser])
    useEffect(() => {
        if(errorFetchNewBill) toast.error(errorFetchNewBill)
    }, [errorFetchNewBill])
    useEffect(() => {
        if(errorFetchRemoveBill) toast.error(errorFetchRemoveBill)
    }, [errorFetchRemoveBill])
    useEffect(() => {
        if(errorSendMoneysToMinfinFromReserveBalance) toast.error(errorSendMoneysToMinfinFromReserveBalance)
    }, [errorSendMoneysToMinfinFromReserveBalance])
    useEffect(() => {
        fetchContracts()
    }, [pageContracts])
    useEffect(() => {
        fetchBillForUser()
    }, [pageBills])
    return (
        <Container className="md:p-20 md:pt-20 pt-20 bg-zinc-100 min-h-[100vh]">
              <ToastContainer 
              position="top-center"
              />
            
            <Flex wrap={'wrap'} gap={'5'} className="!justify-between flex-row md:!flex-row-reverse">
            <Flex direction={'column'} className="wallet-column bg-zinc-50 shadow-lg p-10 w-[100%]"> 
            <Flex gap={'7'} align={'center'} justify={'between'} wrap={'wrap'} className="header-wallet">
            <Heading>
            <Flex align={'center'} justify={'center'} gap={'3'}> 
              <BackpackIcon width={20} height={20} /> Кошелек
              </Flex>
            </Heading>
            <Link to="/balance"> 
            <Flex gap={'1'} align={'center'}>

                <PlusCircledIcon />
               <Text size={'5'}> Пополнить баланс </Text>
              </Flex>
              </Link>
              </Flex>
            <hr />
            <Flex direction={'column'} className="pt-10"> 
            <Flex className="pb-5 border-b mb-5" justify={'between'} direction={'column'}> 
            <Text color='amber' className="mb-5">
                 <Skeleton loading={isLoading}>Баланс (рубли): {userData?.cash_rub}₽</Skeleton>
                </Text>
                <Link to={ROUTES.WITHDRAWAL_RUB_ROUTE}> 
                <Button variant='outline'>
                    <PinTopIcon />
                    Вывести
                </Button>
                </Link>
            </Flex>
           
            <Flex className="pb-5 border-b mb-5" justify={'between'} direction={'column'}> 
            <Text color='amber' className="mb-5">
                 <Skeleton loading={isLoading}>Баланс (рассвет): {userData?.cash_site}</Skeleton>
                </Text>
                <Link to={userData?.role === 'admin' ? '#' : ROUTES.SEND_MONEYS_SITE_ROUTE} className="mb-5"> 
                <Button variant='outline' disabled={userData?.role === 'admin'}>
                    <PinLeftIcon />
                    Отправить
                </Button>
                </Link>
    {userData?.role === 'admin' &&
    <Callout.Root>
	<Callout.Icon>
		<InfoCircledIcon />
	</Callout.Icon>
	<Callout.Text>
		Администратор может отправлять средства только со счетов бюджета!
	</Callout.Text>
</Callout.Root>
}
            </Flex>
             <Flex className="pb-5 border-b mb-5" justify={'between'} direction={'column'}> 
            { userData?.role !== 'minfin' && userData?.role !== 'admin' &&
            <Text color='amber' className="mb-5">
                 <Skeleton loading={isLoading}>Резервный Баланс (рассвет): {userData?.reserve_cash_site}</Skeleton>
                </Text>
}
                {userData?.role !== 'minfin' && userData?.role !== 'admin' ? <Flex align={'center'} wrap={'wrap'} gap={'5'}> 
                {/* <Link to={'#'}> 
                <Button variant='outline'>
                    <PinLeftIcon />
                    Распределить в Министерство Финансов СССР
                </Button>
                </Link> */}
                <BaseModal 
                showButton={ <Button variant='outline' loading={isLoadingSendMoneysToMinfinFromReserveBalance}>
                    <PinLeftIcon />
                    Распределить в Министерство Финансов СССР
                </Button>}
                title="Подтвердите действие"
                description="Все ваши средства с резервного баланса будут распределены в Министерство Финансов СССР!"
                cancelButton={<Button color="red" variant='solid'>Отмена</Button>}
                successButton={<Button color="green" variant="solid" onClick={async () => await fetchSendMoneyesToMinfinFromReserveBalance()}>Подтвердить</Button>}
                />
                {/* <Button variant='soft'>
                    Статистика отправленных средств
                </Button> */}
                </Flex>
                :
                <Link to={AUTHED_ROUTES.PROGRAMMS_MINFIN_ROUTE}> 
                <Button>
                    Программы Министерства
                </Button>
                </Link>
                }
                 
            </Flex>
            <Flex gap={'3'} wrap={'wrap'}>
            <Link to="/transactions">
                <Button variant='soft'>
                    <FileTextIcon />
                    Транзакции
                </Button>
                </Link>
            <Link to='/fin-analitycs'>
             <Button variant='soft'>
                    <FileTextIcon />
                    Фин. Аналитика
                </Button>
            </Link>
            </Flex>
            </Flex>
            </Flex>
            <Flex className="account-column bg-zinc-50 shadow-lg p-10 w-[100%] md:!width-auto" direction={'column'}>
            <Container className="account-heading pb-10">
            <Flex gap={'3'} justify={'between'}> 
            <Heading>
            <Flex align={'center'} gap={'1'} className="mb-3"> 
              <AvatarIcon width={20} height={20} />  Управление аккаунтом
              </Flex>
            </Heading>
            </Flex>
            <hr />
            </Container>
            { !changeData ?
            <Container className="list-data-user">
            <Flex align={'center'} justify={'between'} gap={'6'} wrap={'wrap'} className="border-b"> 
            <Text size={'4'} weight={'bold'}><Skeleton loading={isLoading}>{userData ? UserRoles[userData?.role] : "Загрузка роли..."}</Skeleton></Text>
            {userData?.role !== 'user' ? 
            <Link to={ROUTES.ADMIN_ROUTE}>
            <Flex gap={'1'} align={'center'}> 
            <DesktopIcon />
            Админ панель
            </Flex>
            </Link> 
            : 
            ''}
           </Flex>
            <Flex align={'center'} gap={'2'} className="pb-5 mt-5">
            <IdCardIcon />
                <Text>
                    <Skeleton loading={isLoading}> ID Аккаунта: {userData?.id}</Skeleton>
                </Text>
                </Flex>

                <Flex align={'center'} gap={'2'} className="pb-5">
                    <PersonIcon />
                <Text>
                <Skeleton loading={isLoading}> Логин: {userData?.login} </Skeleton>
                </Text>
                </Flex>
                <Flex align={'center'} gap={'2'} className="pb-5">
                <EnvelopeClosedIcon />
                <Text>
                <Skeleton loading={isLoading}>  Емейл: {userData?.email} </Skeleton>
                </Text>
                </Flex>

                <Flex align={'center'} gap={'2'} className="pb-5">
                    <ArchiveIcon />
                <Text>
                <Skeleton loading={isLoading}>  Номер телефона: {userData?.phone_number} </Skeleton>
                </Text>
                </Flex>
                <Flex align={'center'} gap={'2'} className="pb-5">
                    <IdCardIcon />
                <Text>
                <Skeleton loading={isLoading}>  Номер карты: {userData?.card_number} </Skeleton>
                </Text>
                </Flex>
               
            </Container>
            :
            <Container className="pb-5">
                <Box className="pb-5"> 
                <Text>
                    Емейл
                </Text>
                <TextField.Root placeholder="Введите новый емейл" onChange={e => setEmail(e.target.value)} value={email}></TextField.Root>
                </Box>
                <Box className="pb-5"> 
                <Text>
                    Номер телефона
                </Text>
                <PhoneInput placeholder="Введите новый номер телефона" onChange={e => setPhoneNumber(e.target.value)} value={phoneNumber} />
                </Box>
                <Box className="pb-5"> 
                <Text>
                    Номер карты
                </Text>
                 <CardInput placeholder="Введите новый номер карты" onChange={e => setCardNumber(e.target.value)} value={cardNumber} />
                </Box>
                <Button variant='outline' loading={isLoadingChangingData} onClick={async () => await updateData()}>
                    <UploadIcon />
                    Изменить
                    </Button>
                     
                <Container> 
                </Container>
            </Container>
}
            <Flex gap={'5'} wrap={'wrap'}> 
            <Button color='grass' onClick={() => setChangeData(!changeData)}>
            {
                !changeData ? 
                <> 
                <UpdateIcon />
                Изменить данные
                </>
                :
                <>
                 <ArrowLeftIcon />
                 Назад к данным
                </>
            }
            </Button>
            <Button color='amber' onClick={() => setChangePassword(!changePassword)}>
                <LockOpen2Icon />
                Изменить пароль
            </Button>
            </Flex>
            <div className={`pt-5 ${!changePassword && 'hidden'}`}>
                <Box className="pb-5"> 
                <Text>Старый пароль</Text>
                <PasswordInput value={oldPassword} onChange={e => setOldPassword(e.target.value)} />
                <Text>Новый пароль</Text>
                <PasswordInput value={newPassword} onChange={e => setNewPassword(e.target.value)} />
                </Box>
                <Flex align={'center'} justify={'center'} gap={'3'}> 
                <Button loading={isLoadingPassword} onClick={async () => await updatePassword()} color='orange'>
                    <LockOpen1Icon />
                    Изменить пароль
                </Button>
                <Link to={ROUTES.RESET_PASSWORD_ROUTE}> 
                <Button variant='ghost'>
                    <AccessibilityIcon />
                    Забыли старый пароль?
                </Button>
                </Link>
                </Flex>
            </div>
            </Flex>


            <Flex className="personal-data-column bg-zinc-50 shadow-lg p-10 w-[100%] md:!width-auto" direction={'column'}>
                <Container className="personal-data-heading">
                    <Heading>
                        Личные данные
                    </Heading>
                </Container>
                <hr />

            <Container className="personal-data-info mt-5">

                { !userData?.kyc_verifyed ? 
                <Callout.Root>
	<Callout.Icon>
		<InfoCircledIcon />
	</Callout.Icon>
	<Callout.Text>
		Подтверждение личности нужно для участия в проектах
	</Callout.Text>
</Callout.Root>
    :
    <Callout.Root color='blue'>
	<Callout.Icon>
		<InfoCircledIcon />
	</Callout.Icon>
	<Callout.Text>
		При изменении данных нужно вновь загружать документы, текущая подписка на участие в проекатх сбросится!!!
	</Callout.Text>
</Callout.Root>

}
            </Container>

            <Flex direction={'column'} gap={'3'} className="personal-data-fill mt-10">
                <Container>
                <Text>Фамилия*</Text>
                <TextField.Root 
                placeholder="Иванов" 
                value={secondName} 
                onChange={e => setSecondName(e.target.value)}
                >

                </TextField.Root>
                </Container>

                <Container>
                <Text>Имя*</Text>
                <TextField.Root placeholder="Иван" 
                value={firstName} 
                onChange={e => setFirstName(e.target.value)}
                >

                </TextField.Root>
                </Container>

                   <Container>
                <Text>Отчество</Text>
                <TextField.Root placeholder="Иванович"
                value={surName} 
                onChange={e => setSurName(e.target.value)}
                >

                </TextField.Root>
                </Container>

                  <Flex direction={'column'}>
                 <Text>Документ, подтверждающий личность*</Text>
               <Select.Root 
               size='3' 
               defaultValue="passport_rf"
                value={personDocument || 'Паспорт гражданина РФ'} 
                onValueChange={e => setPersonDocument(e)}
               >
		<Select.Trigger />
		<Select.Content>
			<Select.Item value="Паспорт гражданина РФ">Паспорт гражданина РФ</Select.Item>
			<Select.Item value="Паспорт гражданина СССР">Паспорт гражданина СССР</Select.Item>
            <Select.Item value="Паспорт иностранного гражданина">Паспорт иностранного гражданина</Select.Item>
		</Select.Content>
	</Select.Root>
                </Flex>


                <Container>
                <Text>Серия/Номер паспорта*</Text>
                <TextField.Root 
                placeholder="1111 222222"
                value={seriesNumberPassport} 
                onChange={e => setSeriesNumberPassport(e.target.value)}
                >

                </TextField.Root>
                </Container>

                   <Container>
                <Text>Дата выдачи*</Text>
                <TextField.Root 
                type='date'
                value={dateOfIssue} 
                onChange={e => setDateOfIssue(e.target.value)}
                >

                </TextField.Root>
                </Container>

                   <Container>
                <Text>Кем выдан*</Text>
                <TextField.Root 
                placeholder="УМВД России по Москве"
                value={whomIssue} 
                onChange={e => setWhomIssue(e.target.value)}
                >

                </TextField.Root>
                </Container>

                   <Container>
                <Text>Прописка*</Text>
                <TextField.Root 
                placeholder="г Москва, Арбат 7"
                value={placeOfResidence} 
                onChange={e => setPlaceOfResidence(e.target.value)}
                >

                </TextField.Root>
                </Container>


            </Flex>

            <Flex> 
            <Button color='grass' className="!mt-5" onClick={async () => fetchAddPersonData()} loading={isLoadingFetchPersonData}>
              <CheckCircledIcon />  Сохранить
            </Button>

            </Flex>


            </Flex>


            { userData?.kyc_verifyed ? 
            <Flex className="document-join-service-column bg-zinc-50 shadow-lg p-10 w-[100%] md:!width-auto" direction={'column'}>
                <Container className="mb-5">
                    <Heading>
                        Договор для присоединения
                    </Heading>
                       <hr />
                </Container>
              
                <Container className="document-join-service-info mb-5"> 
               	<Callout.Root color="green">
		<Callout.Icon>
            <CheckIcon />
		</Callout.Icon>
		<Callout.Text>
            {!userData.joined_service ? 
            'Вы успешно прошли проверку! Ознакомьтесь с договором и подпишите его'
            :
            'Вы можете участвовать в проектах'
            }
		</Callout.Text>
	</Callout.Root>
    </Container>

            <Flex wrap={'wrap'} gap={'5'}>
                <Flex align={'center'} gap={'3'}>
                    <Link to={'#'}>📑 Договор для присоединения</Link>  
                       <BaseModal 
                        maxWidth="700px"
                        showButton={<Button>Читать</Button>}
                        title={"Договор для присоединения"}
                        description={renderContentPdfModalContractJoiningService}
                        cancelButton={<></>}
                        successButton={<Button>Готово</Button>}
                    />
                </Flex>
                <Flex gap={'5'}>
                    {!userData.joined_service ? 
                    <Button color="grass" loading={isLoadingFetchSetJoiningService} onClick={async () => await fetchSetJoiningService()}>
                      <CheckCircledIcon />  Подписать
                    </Button>
                    :
                      <Button color="red" loading={isLoadingFetchUnsetJoiningService} onClick={async () => await fetchUnsetJoiningService()}>
                      <CrossCircledIcon /> Отозвать подпись
                    </Button>
}
                </Flex>
            </Flex>

            </Flex>

            :
            <></>

            }

               <Flex className="your-contracts-column bg-zinc-50 shadow-lg p-10 w-[100%] md:!width-auto" direction={'column'}>

                 <Container className="mb-5">
                    <Heading>
                       Проверка документов
                    </Heading>
                       <hr />
                </Container>

                <Container className="form-upload-documents mb-5">
                    <Heading size={'4'} className="mb-5">
                        Отправка документов
                    </Heading>

                    <Container className="mb-3"> 
                    <Text>
                        Название*
                    </Text>
                    <TextField.Root placeholder="Верификация" value={titleContract} onChange={e => setTitleContract(e.target.value)}>

                    </TextField.Root>
                    </Container>

                       <Container className="mb-3"> 
     <Flex direction={'column'}>
                 <Text>Тема*</Text>
               <Select.Root size='3' defaultValue="Загрузка личных документов" value={typeContract} onValueChange={e => setTypeContract(e)}>
		<Select.Trigger />
		<Select.Content>
			<Select.Item value="Загрузка личных документов">Загрузка личных документов</Select.Item>
			<Select.Item value="Подписанные Договоры/Соглашения">Подписанные Договоры/Соглашения</Select.Item>
		</Select.Content>
	</Select.Root>
    { typeContract === "Загрузка личных документов" ?
    <Callout.Root color='blue' className="mt-5">
	<Callout.Icon>
		<InfoCircledIcon />
	</Callout.Icon>
	<Callout.Text>
		Загрузите подтверждающие документы
	</Callout.Text>
</Callout.Root>
:
<></>
}
                </Flex>

                    </Container>

                {typeContract === 'Загрузка личных документов' ? 

                
                <Container className="fields-upload-perosnal-documents">
                <Text weight={'medium'}>Свидетельство о рождении</Text>
                <Container className="mb-3">
                    <FileInput 
                    id="file_birth_certificate"
                        classNamelabel="w-[50%] h-[200px] mb-5"
                        setFileInStore={setFileBirthSertificate}
                        accept="application/pdf, image/*"
                        contentLabel={<Text>📑 Загрузите файлы (Максимальный размер файла 5 МБ)*</Text>}
                            
                    />
                </Container>

                <Container className="mb-3">

                        {fileBirthCertificate.map(file => {
                                    return (
                                    <Flex align={'center'} gap={'2'}>
                                   <Button color="red" onClick={() => handleRemoveFilePDf(file.id, setFileBirthSertificate)}> <Cross1Icon /></Button> <Text>📑 {file.name}</Text>
                                    </Flex>
                                    )
                                })}

                </Container>


                    <Container className="mb-3">
                    <Text weight={'medium'}>Паспорт</Text>
                    <FileInput 
                            id="file_passport"
                            classNamelabel="w-[50%] h-[200px] mb-5"
                            setFileInStore={setFilePassport}
                            accept="application/pdf, image/*"
                            contentLabel={<Text>📑 Загрузите файлы (Максимальный размер файла 5 МБ)*</Text>}
                            multiple
                    />
                </Container>

                <Container className="mb-3">

                        {filePassport.map(file => {
                                    return (
                                    <Flex align={'center'} gap={'2'}>
                                   <Button color="red" onClick={() => handleRemoveFilePDf(file.id, setFilePassport)}> <Cross1Icon /></Button> <Text>📑 {file.name}</Text>
                                    </Flex>
                                    )
                                })}

                </Container>


                    <Container className="mb-3">
                    <Text weight={'medium'}>Автобиография</Text>
                    <FileInput 
                    id="file_autobiography"
                        classNamelabel="w-[50%] h-[200px] mb-5"
                           setFileInStore={setFileAutobiography}
                            accept="application/pdf, image/*"
                            contentLabel={<Text>📑 Загрузите файлы (Максимальный размер файла 5 МБ)*</Text>}
                            multiple
                    />
                </Container>

                <Container className="mb-3">

                        {fileAutobiography.map(file => {
                                    return (
                                    <Flex align={'center'} gap={'2'}>
                                   <Button color="red" onClick={() => handleRemoveFilePDf(file.id, setFileAutobiography)}> <Cross1Icon /></Button> <Text>📑 {file?.name}</Text>
                                    </Flex>
                                    )
                                })}

                </Container>

                    <Container className="mb-3">
                     <Text weight={'medium'}>Вкладыш/Справка о гражданстве СССР</Text>
                    <FileInput 
                    id="file_nationality_certificate"
                        classNamelabel="w-[50%] h-[200px] mb-5"
                           setFileInStore={setFileNationalityCertificate}
                            accept="application/pdf, image/*"
                            contentLabel={<Text>📑 Загрузите файлы (Максимальный размер файла 5 МБ)</Text>}
                            multiple
                    />
                </Container>

                <Container className="mb-3">

                        {fileNationalityCertificate.map(file => {
                                    return (
                                    <Flex align={'center'} gap={'2'}>
                                   <Button color="red" onClick={() => handleRemoveFilePDf(file.id, setFileNationalityCertificate)}> <Cross1Icon /></Button> <Text>📑 {file.name}</Text>
                                    </Flex>
                                    )
                                })}

                </Container>
                     <Container className="mb-3">
                    <Text weight={'medium'}>Прочие документы (военный билет, трудовая книжка, документы об образовании)</Text>
                    <FileInput 
                    id="file_other_documents"
                        classNamelabel="w-[50%] h-[200px] mb-5"
                           setFileInStore={setFileOtherDocuments}
                            accept="application/pdf, image/*"
                            contentLabel={<Text>📑 Загрузите файлы (Максимальный размер файла 5 МБ)</Text>}
                            multiple
                    />
                </Container>

                <Container className="mb-3">

                        {fileOtherDocuments.map(file => {
                                    return (
                                    <Flex align={'center'} gap={'2'}>
                                   <Button color="red" onClick={() => handleRemoveFilePDf(file.id, setFileOtherDocuments)}> <Cross1Icon /></Button> <Text>📑 {file?.name}</Text>
                                    </Flex>
                                    )
                                })}

                </Container>
                </Container>
                :
                <Container className="field-upload-other-documents">
                        <Container className="mb-3">
                    <FileInput 
                    id="file_upload_other_documents"
                        classNamelabel="w-[50%] h-[200px] mb-5"
                            setFileInStore={setPDFFileContract}
                            accept="application/pdf, image/*"
                            contentLabel={<Text>📑 Загрузите файлы (Максимальный размер файла 5 МБ)*</Text>}
                            multiple
                    />
                </Container>

                <Container className="mb-3">

                        {pdfFileContract.map(file => {
                                    return (
                                    <Flex align={'center'} gap={'2'}>
                                   <Button color="red" onClick={() => handleRemoveFilePDf(file.id, setPDFFileContract)}> <Cross1Icon /></Button> <Text>📑 {file.name}</Text>
                                    </Flex>
                                    )
                                })}

                </Container>
                </Container>
}
                <Button onClick={async () => typeContract === 'Загрузка личных документов' ? await fetchContractPersonalInformation() : await fetchContract()} loading={isLoadingFetchContract || isLoadingFetchContractPersonalInformation}>
                   <FileTextIcon /> Отправить на проверку
                </Button>
                </Container>
                

            <Heading size={'4'}>
                Договора/соглашения/документы
            </Heading>
                <hr />
              <ScrollArea type="scroll" scrollbars="vertical" className="mt-5 max-h-[630px]">
                    {isLoadingFetchContracts && <Spinner />}
                       {contracts.map(item => {
                    return (
                         <Flex align={'center'} justify={'between'} className="mb-5">
                            <Flex direction={'column'}>
                           <Text>{item.id}.{item.title}</Text>
                            <Text>Пользователь: <Link to={`/profile/${item.user.id}`}>{item.user.login}</Link></Text>
                            </Flex>
                            <Flex gap={'3'} align={'center'} justify={'end'}> 
                            <Button onClick={() => navigate(`${ROUTES.UPLOADED_DOCUMENT_ROUTE}/${item.id}`)}>Открыть</Button>
                             <Badge color={item.status === 'В обработке' ? 'orange' : item.status === 'Пройдено' ? 'grass' : 'red'}>{item.status}</Badge>
                            </Flex>
                         </Flex>
                    )
                })}
              </ScrollArea>
            <Pagination total={totalCountContracts} count={limitContracts} activeIndex={pageContracts} onChangeIndex={setPageContracts}  />
            </Flex>


            </Flex>
        
            <Flex className="bills bg-zinc-50 shadow-lg p-10 w-[100%] md:!width-auto" direction={'column'} wrap={'wrap'}>
                <Container> 
                <Heading>Заявление-Требование</Heading>
                <hr />
                    <Container className="field-upload-other-documents">
                    <Container className="mb-3">
                    <Container><Link to={settingsSite?.bill_template_document || ''} download>📑 Скачать образц шаблона</Link></Container>
                    <Container><Link to={AUTHED_ROUTES.BILL_FILL}>📝После заполнения Заявление необходимо отравить в ГРП и всем получателям указанных в заявлении</Link></Container>
                    <FileInput 
                    id="file_upload_other_documents"
                        classNamelabel="w-[100%] h-[200px] mb-5"
                            setFileInStore={setNewBillFile}
                            accept=".docx"
                            contentLabel={<Text>📑 Загрузите файлы (Максимальный размер файла 5 МБ)*</Text>}
                            multiple
                    />
                </Container>

                <Container className="mb-3">

                    {newBillFile.length ?
                    <Flex align={'center'} gap={'2'}>
                    <Text>📑 {newBillFile[0].name}</Text>
                    </Flex>
                    :
                    ''
                    }
                               

                </Container>
                <Button variant="solid" color="grass" onClick={async () => await fetchNewBill()} loading={isLoadingFetchNewBill}>Создать счет</Button>
                </Container>
                </Container>
                <Container> 
                <Heading>Мои Заявления-Требования</Heading>
                <hr />
                <ScrollArea type="scroll" scrollbars="vertical" className="mt-5 max-h-[630px]">
                    {isLoadingBillForUser}
                    {
                        bills.map(item => {
                            return (
                                <Container className="mb-4">
                                    Номер: {item.id}. <Link download to={item.document}>Скачать docx</Link> <Link download to={item.document_pdf}>Скачать pdf</Link> <Button variant="solid" color="red" onClick={async () => await fetchRemoveBill(item.id)} loading={isLoadingFetchRemoveBill}>Удалить</Button>
                                </Container>
                            )
                        })
                    }
                </ScrollArea>
                <Pagination total={totalBills} count={limitBills} activeIndex={pageBills} onChangeIndex={setPageBills} />
                </Container>
            </Flex>

        </Container>
        
    )
}